export default __webpack_public_path__ + "static/media/linkedin.f0c79589.svg";